import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("chica_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatPrice = (n) =>
  `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export const RESTAURANT = {
  name: "CHICA",
  tagline: "Fine Dining · Lounge · Nightclub",
  address:
    "Pranav Tower, 210, Rajpur Rd, opposite GRD, IAS Officers Colony, Rajpur, Dehradun, Uttarakhand 248009",
  shortAddress: "Rajpur Road, Dehradun",
  phone: "+91 95209 28111",
  phoneRaw: "919520928111",
  hours: "Open daily · 12:00 — 22:00",
  email: "chicadehradun@gmail.com",
  offerPercent: 15,
  offerCopy: "15% off all dining when you reserve through chica.com",
  links: {
    whatsapp:
      "https://wa.me/919520928111?text=Hello%20CHICA%2C%20I%20would%20like%20to%20reserve%20a%20table.",
    zomato: "https://zomato.onelink.me/xqzv/5c5lhkgx",
    swiggy:
      "https://swiggy.onelink.me/BVRZ?af_dp=swiggydiners%3A%2F%2Fdetails%2F1300026%3Fsource%3D",
    eazydiner:
      "https://www.eazydiner.com/dehradun/chica-raipur-dehradun-dehradun-710218",
    instagram: "https://www.instagram.com/chicadoon",
    facebook: "https://www.instagram.com/chicadoon",
    googleMaps:
      "https://www.google.com/maps/search/?api=1&query=Pranav+Tower+Rajpur+Road+Dehradun",
  },
};

export const LOGO = {
  cream: "/brand/chica-logo-cream.png",
  white: "/brand/chica-logo-white.png",
  full: "/brand/chica-logo.png",
};

const P = "/brand/photos";

export const MEDIA = {
  // Hero — exterior
  hero: `${P}/hero-new.jpg`,
  // Featured signature dish (food)
  dish: `${P}/food-indian-spread.jpg`,
  // Gallery feature (large ambience block on Home)
  galleryFeature: `${P}/gallery-new.jpg`,
  // Interior ambience
  interior: `${P}/interior-dining.jpg`,
  bar: `${P}/interior-bar.jpg`,
  hall: `${P}/interior-hall.jpg`,
  atrium: `${P}/interior-atrium.jpg`,
  // Rooftop / outdoor
  rooftopDusk: `${P}/rooftop-dusk.jpg`,
  rooftopDay: `${P}/rooftop-day.jpg`,
  rooftopView: `${P}/rooftop-view.jpg`,
  rooftopTerrace: `${P}/rooftop-terrace.jpg`,
  // Plating / food
  plating: `${P}/food-pizza.jpg`,
  sushi: `${P}/food-sushi.jpg`,
  bao: `${P}/food-bao.jpg`,
  tart: `${P}/food-tart.jpg`,
  tiramisu: `${P}/food-tiramisu.jpg`,
  // Drinks
  wine: `${P}/drink-cloche.jpg`,
  cocktail: `${P}/drink-pink.jpg`,
};

// Reservation slots: continuous 12:00 – 21:30 (last seating)
export const RESERVATION_SLOTS = (() => {
  const slots = [];
  for (let h = 12; h <= 21; h++) {
    slots.push(`${String(h).padStart(2, "0")}:00`);
    if (h < 21 || h === 21) {
      slots.push(`${String(h).padStart(2, "0")}:30`);
    }
  }
  // Cap at 21:30
  return slots.filter((t) => t <= "21:30");
})();

export const MENU_CATEGORIES = [
  { key: "small_plates", label: "Small Plates" },
  { key: "indian", label: "Indian" },
  { key: "asian", label: "Asian & Sushi" },
  { key: "italian", label: "Italian" },
  { key: "bbq", label: "BBQ & Grill" },
  { key: "desserts", label: "Desserts" },
  { key: "drinks", label: "Mocktails" },
  { key: "cocktails", label: "Cocktails" },
  { key: "wine", label: "Wine & Beer" },
];
